import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medical-supply";
export const pagingMedicalSupply = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const pagingMedicalSupplyOrder = (searchObject) => axios.post(API_PATH + "/search-by-page-medical-supply-order", searchObject);

export const getMedicalSupplyById = (medicalSupplyId) => axios.get(API_PATH + "/getbyid/" + medicalSupplyId);

export const saveOrUpdateMedicalSupply = medicalSupply => axios.post(API_PATH + "/save-or-update", medicalSupply);

export const deleteMedicalSupply = medicalSupplyId => axios.delete(API_PATH + '/mark-delete/' + medicalSupplyId);

export const getAllMedicalSupply = () => axios.get(API_PATH + '/get-all');

export const saveMedicalSupplySyncStore = (result) => axios.post(API_PATH + "/sync-medical-supply-from-store", result);

export const getMedicalSupplyOderById = (medicalSupplyId) => axios.get(API_PATH + "/get-by-id-medical-supply-order/" + medicalSupplyId);

export const removeMedical = (id) => axios.delete(API_PATH + "/remove-medical-supply-order/" + id);